module.exports = __webpack_public_path__ + "static/img/驾驶舱@4x.fdeab584.png";